import { LoginService } from '@services/login.service';
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AccountService } from './account.service';
import { Config } from '@config/config.service';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(
    public router: Router,
    private config: Config,
    private accountService: AccountService,
    private loginService: LoginService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.loginService.isLoggedIn) {
      if (!this.accountService.profileData) {
        this.accountService.setProfileData();
      }

      if (!route.data.expectedRoles.includes(this.accountService.profileData.roleId)) {
        this.router.navigate([this.config.mainPage]);
        return false;
      }
    }
    return true;
  }
}
